import { getCustomerSetPriceTotal } from "apollo/reactive-variables/configuratorVariables"

const ExcelJS = require("exceljs")
import React from "react"

const headerFields = [
  "Dodavatel",
  "Kont.osoba",
  "Název firmy",
  "Adresa",
  "Telefon",
  "Email",
  "WWW",
  "IČ",
  "DIČ",
  "Název projektu",
]

const priceFields = [
  "# Položka",
  "Produktový kód",
  "Název",
  "Počet ks",
  "Cena za 1ks bez DPH (CZK)",
  "Cena celkem bez DPH (CZK)",
]

const boldHeaderFont = { name: "Arial", size: 8, bold: true }
const footerFont = { name: "Arial", size: 8 }
const boldPriceFont = { name: "Arial", size: 10, bold: true }

export const exportToExcel = (customerSets, productSubLine) => {
  const workbook = new ExcelJS.Workbook()
  customerSets.map(customerSet => {
    const worksheet = workbook.addWorksheet(customerSet.name, {
      pageSetup: { paperSize: 9, orientation: "landscape" },
    })
    worksheet.getColumn("A").width = 15
    worksheet.getColumn("B").width = 17
    worksheet.getColumn("C").width = 40

    const dateColumnPosition = getHeader(worksheet)

    const priceTableHeaderNamesPosition = getPriceTableHeader(
      worksheet,
      dateColumnPosition
    )

    const activeSetPosition = priceTableHeaderNamesPosition + 1
    const activeSetRow = worksheet.getRow(activeSetPosition)
    activeSetRow.getCell(1).value = customerSet.name
    activeSetRow.getCell(1).font = boldPriceFont
    activeSetRow.getCell(1).border = {
      right: { style: "thick", color: { argb: "00000000" } },
    }
    worksheet.mergeCells("A" + activeSetPosition + ":F" + activeSetPosition)

    const { rows, totalPrice } = getRows(
      customerSet,
      worksheet,
      activeSetPosition
    )

    const totalPricePosition = getTotalPrice(
      worksheet,
      rows,
      activeSetPosition,
      customerSet,
      totalPrice
    )

    getFooter(worksheet, totalPricePosition)
  })
  const FILENAME = `${customerSets.map(cs => cs.name).join("-")}.xlsx`
  workbook.xlsx.writeBuffer().then(function (data: Blob) {
    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    })
    const url = window.URL.createObjectURL(blob)
    const anchor = document.createElement("a")
    anchor.href = url
    anchor.download = FILENAME
    anchor.click()
    window.URL.revokeObjectURL(url)
  })
}

const getFooter = (worksheet, totalPricePosition) => {
  const footerPosition = totalPricePosition + 2
  const footerContacts = worksheet.getCell("A" + footerPosition)
  footerContacts.value =
    "Zákaznické centrum Schneider Electric s.r.o. CZ, tel: +420 225 382 919, podpora@se.com"
  footerContacts.font = footerFont

  const footerDisclaimer = worksheet.getCell("A" + (footerPosition + 1))
  footerDisclaimer.value =
    "Nejedná se o cenovou nabídku, ale o soupis materiálu s orientačními cenami."
  footerDisclaimer.font = footerFont
}

const getTotalPrice = (
  worksheet,
  rows,
  activeSetPosition,
  customerSet,
  totalPriceAmount
) => {
  const emptyLineBeforeTotalPricePosition = activeSetPosition + rows.length + 1
  const emptyLineBeforeTotalPrice = worksheet.getRow(
    emptyLineBeforeTotalPricePosition
  )
  emptyLineBeforeTotalPrice.getCell(6).border = {
    right: { style: "thick", color: { argb: "00000000" } },
  }
  const totalPricePosition = activeSetPosition + rows.length + 2
  const totalPrice = worksheet.getRow(totalPricePosition)
  for (let i = 1; i <= 6; i++) {
    if (i === 1) {
      totalPrice.getCell(i).font = boldPriceFont
      totalPrice.getCell(i).value = "Celková cena bez DPH (CZK)"
    }
    totalPrice.getCell(i).border = {
      top: { style: "double", color: { argb: "00000000" } },
      bottom: { style: "thick", color: { argb: "00000000" } },
    }
    if (i === 6) {
      totalPrice.getCell(i).font = boldPriceFont
      totalPrice.getCell(i).numFmt = "0.00"
      totalPrice.getCell(i).value =
        totalPriceAmount > 0
          ? totalPriceAmount
          : getCustomerSetPriceTotal(customerSet)
      totalPrice.getCell(i).border = {
        top: { style: "double", color: { argb: "00000000" } },
        right: { style: "thick", color: { argb: "00000000" } },
        bottom: { style: "thick", color: { argb: "00000000" } },
      }
    }
  }

  return totalPricePosition
}

const getPriceTableHeader = (worksheet, dateColumnPosition) => {
  const priceTableHeaderPosition = dateColumnPosition + 3
  const priceTableHeader = worksheet.getRow(priceTableHeaderPosition)
  for (let i = 1; i <= 6; i++) {
    if (i === 1) {
      priceTableHeader.getCell(i).font = boldPriceFont
      priceTableHeader.getCell(i).value = "Orientační cena přístrojů"
    }
    priceTableHeader.getCell(i).border = {
      top: { style: "thick", color: { argb: "00000000" } },
    }

    if (i === 6) {
      priceTableHeader.getCell(i).border = {
        top: { style: "thick", color: { argb: "00000000" } },
        right: { style: "thick", color: { argb: "00000000" } },
      }
    }
  }

  const priceTableHeaderNamesPosition = priceTableHeaderPosition + 1
  const priceTableHeaderNames = worksheet.getRow(priceTableHeaderNamesPosition)
  priceFields.forEach((field, index) => {
    const priceTableHeaderCell = priceTableHeaderNames.getCell(index + 1)
    priceTableHeaderCell.alignment = { wrapText: true }
    priceTableHeaderCell.font = boldPriceFont
    priceTableHeaderCell.value = field
    if (priceFields.length - 1 === index) {
      priceTableHeaderCell.border = {
        right: { style: "thick", color: { argb: "00000000" } },
      }
    }
  })

  return priceTableHeaderNamesPosition
}

const getHeader = worksheet => {
  headerFields.forEach((field, index) => {
    worksheet.getCell("A" + (index + 2)).font = boldHeaderFont
    worksheet.getCell("A" + (index + 2)).value = field
    worksheet.mergeCells("B" + (index + 2) + ":C" + (index + 2))
  })

  const dateColumnPosition = headerFields.length + 2
  const dateColumn = worksheet.getCell("A" + dateColumnPosition)
  dateColumn.font = boldHeaderFont
  dateColumn.value = "Datum"

  const dateColumnValue = worksheet.getCell("B" + dateColumnPosition)
  worksheet.mergeCells("B" + dateColumnPosition + ":C" + dateColumnPosition)
  dateColumnValue.style = { numFmt: "dd/mm/yyyy" }
  dateColumnValue.value = new Date()
  worksheet.getRow(dateColumnPosition).alignment = { horizontal: "left" }

  return dateColumnPosition
}

const getRows = (customerSet, worksheet, activeSetPosition) => {
  const rows = []
  const cart = customerSet.cart
  if (cart.devices?.length) {
    cart.devices.map(item => {
      rows.push({
        name: item.product?.pdfName || item.product?.Name,
        partNumber: item.product?.PartNumber,
        unitPrice: item.product?.Price,
        count: item.count,
      })
    })
  }
  if (cart.frames?.length) {
    cart.frames.map(item => {
      rows.push({
        name: item.product?.pdfName || item.product?.Name,
        partNumber: item.product?.PartNumber,
        unitPrice: item.product?.Price,
        count: item.count,
      })
    })
  }
  if (cart.decorativeFrames?.length) {
    cart.decorativeFrames.map(item => {
      rows.push({
        name: item.product?.pdfName || item.product?.Name,
        partNumber: item.product?.PartNumber,
        unitPrice: item.product?.Price,
        count: item.count,
      })
    })
  }
  if (cart.constructionFrames?.length) {
    cart.constructionFrames.map(item => {
      rows.push({
        name: item.product?.pdfName || item.product?.Name,
        partNumber: item.product?.PartNumber,
        unitPrice: item.product?.Price,
        count: item.count,
      })
    })
  }

  let totalPrice = 0
  if (!rows.length) {
    if (customerSet.visualizer?.selectedParts?.device) {
      const device = customerSet.visualizer?.selectedParts?.device
      rows.push({
        name: device.Name,
        partNumber: device.PartNumber,
        unitPrice: device.Price,
        count: 1,
      })
      totalPrice = totalPrice + device.Price
    }
    if (customerSet.visualizer?.selectedParts?.frame) {
      const frame = customerSet.visualizer?.selectedParts?.frame
      rows.push({
        name: frame.Name,
        partNumber: frame.PartNumber,
        unitPrice: frame.Price,
        count: 1,
      })
      totalPrice = totalPrice + frame.Price
    }
    if (customerSet.visualizer?.selectedParts?.decorativeFrame) {
      const decorativeFrame =
        customerSet.visualizer?.selectedParts?.decorativeFrame
      rows.push({
        name: decorativeFrame.Name,
        partNumber: decorativeFrame.PartNumber,
        unitPrice: decorativeFrame.Price,
        count: 1,
      })
      totalPrice = totalPrice + decorativeFrame.Price
    }
  }

  rows.forEach((row, index) => {
    const itemRow = worksheet.getRow(activeSetPosition + (index + 1))
    itemRow.getCell(1).value = index + 1
    itemRow.getCell(1).alignment = { horizontal: "left" }
    itemRow.getCell(2).value = row.partNumber
    itemRow.getCell(3).value = row.name
    itemRow.getCell(4).value = row.count
    itemRow.getCell(5).numFmt = "0.00"
    itemRow.getCell(5).value = row.unitPrice
    itemRow.getCell(6).numFmt = "0.00"
    itemRow.getCell(6).value = row.unitPrice * row.count
    itemRow.getCell(6).border = {
      right: { style: "thick", color: { argb: "00000000" } },
    }
  })

  return { rows, totalPrice }
}
